import {IAddress} from "../interfaces/address";

/**
 * serializable user address
 */
export class Address implements IAddress {
  public address;
  public firstname: string;
  public lastname: string;
  public street: string;
  public streetnumber : string;
  public postalcode: string|number;
  public location?: string;
  public identifier: number;
  public lat : number;
  public lng: number;
  public floor?: string;
  public political?: string;
  public sublocality?: string;

  public serialize(){
    return {
      firstname: this.firstname,
      lastname : this.lastname,
      street: this.street,
      streetnumber: this.streetnumber,
      postalcode: this.postalcode,
      location: this.location,
      lat: this.lat,
      floor: this.floor,
      lng: this.lng,
      political: this.political,
      sublocality: this.sublocality
    }
  }

  constructor(payload: IAddress) {
    this.firstname = payload.firstname;
    this.lastname = payload.lastname;
    this.street = payload.street;
    this.postalcode = payload.postalcode;
    this.streetnumber = payload.streetnumber;
    this.location = payload.location;
    this.lat = payload.lat;
    this.floor = payload.floor;
    this.lng = payload.lng;
    this.sublocality = payload.sublocality;
    this.political = payload.political;
  }

  static fromGeolocation(payload: IGeoJSONPayload) {
    let street;
    let streetnumber;
    let postalcode;
    let location;
    let political;
    let sublocality;
    payload.address_components.forEach((addressComponent) => {
      switch (addressComponent.types[0]) {
        case "street_number":
          streetnumber = addressComponent.short_name;
          break;

        case "route":
          street = addressComponent.short_name;
          break;

        case "locality":
          location = addressComponent.short_name;
          break;

        case "political":
          political = addressComponent.short_name;
          sublocality = addressComponent.short_name;
          break;

        case "postal_code":
          postalcode = addressComponent.short_name;
          break;

        case "administrative_area_level_1":
          break;

        case "country":
          break;

        default:
          // not supported
          break;

      }
    });

    return new Address({
      street,
      location,
      streetnumber,
      postalcode,
      firstname: "",
      lastname: "",
      political,
      sublocality,
      lat:0,
      lng:0,
      floor: ""
    });
  }
}


export interface IGeoJSONPayload {
  address_components: IAddressComponentPayload[];
  geometry: any;
}

export interface IAddressComponentPayload {
  long_name: string;
  short_name: string;
  types: string[];
}



// WEBPACK FOOTER //
// ./src/app/classes/address.ts